import React, { useState } from "react";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CopyrightIcon from "@mui/icons-material/Copyright";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import EngineeringIcon from "@mui/icons-material/Engineering";
// import OpenInFullIcon from "@mui/icons-material/OpenInFull";

import { Link } from "react-router-dom";

let calendarStyles = {
  timesheet: "var(--timesheets-secondary)",
  quote: "var(--quotes-secondary)",
  jobsheet: "var(--jobsheets-secondary)",
};

const CalendarCard = ({ details }) => {
  let [bodyInfo, toggleBodyInfo] = useState(true);
  // let [expandCard, setExpandCard] = useState(false);
  let {
    authorisedBy,
    name,
    refNumber,
    bookedInDateTime,
    jobDetails,
    address,
    paid,
    sent,
    cert,
    postcode,
    status,
    subcontracted,
    subcontractorPaid,
    // jobDayOrderNumber,
  } = details;

  function toggleInformation() {
    toggleBodyInfo((prevState) => !prevState);
  }

  // <div className="job-tile" key={details.uid}>
  /* <Link
                            to={{
                              pathname: `/${details.primaryType}/${details.uid}`,
                              state: { timesheet: details },
                            }}
                          > */
  /* </Link> */
  // </div>

  return (
    <div className={`calendar-card`}>
      {/* <div className={`calendar-card ${expandCard ? "card-expanded" : ""}`}>
       <button
        onClick={() => {
          setExpandCard((pS) => !pS);
        }}
        className="expand-btn"
      >
        <ExpandMoreIcon />
      </button> */}

      <div
        style={{
          background: `${status === "provisional" ? "#6a6767" : calendarStyles[details.primaryType]}`,
        }}
        className="card-header"
      >
        <Link
          to={{
            pathname: `/${details.primaryType}/${details.uid}`,
            state: { data: details, preservePrimary: true },
          }}
        >
          <p className="name">{authorisedBy || name || refNumber || "No Name"} </p>
        </Link>
        <p className="time">{dateTimeFormatter(bookedInDateTime, "t_short")}</p>
      </div>
      <div className={`card-body`}>
        {bodyInfo ? (
          <>
            <div className="info">
              <p>{address}</p>
              <p>{postcode}</p>
            </div>
            <button className="info-icon" onClick={toggleInformation}>
              <LocationOnIcon style={{ fontSize: 16 }} />
            </button>
          </>
        ) : (
          <>
            <div className="info">
              <p>{jobDetails}</p>
            </div>
            <button onClick={toggleInformation} className="info-icon">
              <InfoOutlinedIcon style={{ fontSize: 16 }} />
              {/* <EditIcon style={{ fontSize: 14 }} /> */}
            </button>
          </>
        )}
      </div>

      {/* Status Symbols: Paid, Sent and Cert*/}
      {paid && <div className="calendar-paid-bar"></div>}
      {(sent || cert) && (
        <div className="calendar-status-icons">
          {cert && <CopyrightIcon style={{ fontSize: 14, color: "#ef2c2c" }} />}
          {sent && <DoubleArrowIcon style={{ fontSize: 14 }} />}
          {subcontractorPaid && <HowToRegIcon style={{ fontSize: 14, color: "var(--black)" }} />}
        </div>
      )}
      {subcontracted && (
        <div className="calendar-subcontracted">
          <EngineeringIcon style={{ fontSize: 14 }} />
        </div>
      )}
    </div>
  );
};

export default CalendarCard;
